import Router from "next/router";
import { Button } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";

type Props = {
  sub: string;
};

export const EditUserButton = ({ sub }: Props) => {
  const onClick = () => {
    Router.push("/edit-user/" + sub);
  };

  return (
    <Button variant="secondary" onClick={onClick} css={buttonMargin}>
      編集
    </Button>
  );
};
const buttonMargin = css({
  marginLeft: "16px",
});
